import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { getIncomeChart, getReportOverview, getReportOverviewCancel, getReportOverviewComplete, getReportOverviewInprogress, getReportOverviewOpen, getReportTopSale } from 'services/dashboard'
import {
  GetFactoryIncomeChartResponse,
  GetFactoryOverviewCancelResponse,
  GetFactoryOverviewCompleteResponse,
  GetFactoryOverviewInprogressResponse,
  GetFactoryOverviewOpenResponse,
  GetFactoryOverviewResponse,
  GetFactoryTopSaleReportResponse,
  InputGetFactoryIncomeChart,
  InputGetFactoryOverview,
} from 'services/interface'

export const useGetReportOverview = (input: InputGetFactoryOverview): UseQueryResult<GetFactoryOverviewResponse, Error> => {
  return useQuery<GetFactoryOverviewResponse, Error>({
    queryKey: ['getReportOverview', input.period, input.start_date, input.end_date],
    queryFn: () => getReportOverview(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}

export const useGetReportOverviewOpen = (input: InputGetFactoryOverview): UseQueryResult<GetFactoryOverviewOpenResponse, Error> => {
  return useQuery<GetFactoryOverviewOpenResponse, Error>({
    queryKey: ['getReportOverviewOpen', input.period, input.start_date, input.end_date],
    queryFn: () => getReportOverviewOpen(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}

export const useGetReportOverviewComplete = (input: InputGetFactoryOverview): UseQueryResult<GetFactoryOverviewCompleteResponse, Error> => {
  return useQuery<GetFactoryOverviewCompleteResponse, Error>({
    queryKey: ['getReportOverviewComplete', input.period, input.start_date, input.end_date],
    queryFn: () => getReportOverviewComplete(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}

export const useGetReportOverviewCancel = (input: InputGetFactoryOverview): UseQueryResult<GetFactoryOverviewCancelResponse, Error> => {
  return useQuery<GetFactoryOverviewCancelResponse, Error>({
    queryKey: ['getReportOverviewCancel', input.period, input.start_date, input.end_date],
    queryFn: () => getReportOverviewCancel(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}

export const useGetReportOverviewInprogress = (input: InputGetFactoryOverview): UseQueryResult<GetFactoryOverviewInprogressResponse, Error> => {
  return useQuery<GetFactoryOverviewInprogressResponse, Error>({
    queryKey: ['getReportOverviewInprogress', input.period, input.start_date, input.end_date],
    queryFn: () => getReportOverviewInprogress(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}

export const useGetReportTopSale = (input: InputGetFactoryOverview): UseQueryResult<GetFactoryTopSaleReportResponse, Error> => {
  return useQuery<GetFactoryTopSaleReportResponse, Error>({
    queryKey: ['getReportTopSale', input.period, input.start_date, input.end_date],
    queryFn: () => getReportTopSale(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}

export const useGetIncomeChart = (input: InputGetFactoryIncomeChart): UseQueryResult<GetFactoryIncomeChartResponse, Error> => {
  return useQuery<GetFactoryIncomeChartResponse, Error>({
    queryKey: ['getIncomeChart', input.less_year, input.start_date, input.end_date],
    queryFn: () => getIncomeChart(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}
